import React, { useEffect, useState } from 'react'
import './feed-general-styles.scss'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { summaryService } from '../../api'
import { LoadingOutlined } from '@ant-design/icons'
import { getTopicsModalIsLoading, getTopicsModalIsOpen, getTopicsModalList, getTopicsModalMainTopic } from '../../redux/selectors/topics-modal.selectors'
import { showChangePostTonalModal } from '../../redux/actions/change-post-tonal.actions'
import MainThemes from '../main-themes/main-themes'
import { useAppDispatch } from '../../redux/store/hooks'

const FeedGeneral: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const mainTopic = useSelector(getTopicsModalMainTopic)
    const topicsModalPosts = useSelector(getTopicsModalList)
    const topicsModalIsLoading = useSelector(getTopicsModalIsLoading)
    const dispatch = useAppDispatch()
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [mentioningSelected, setMentioningSelected] = useState(false)
    const [postList, setPostList] = useState(topicsModalPosts)
    const [tonal, setTonal] = useState<number>();
    const [changes, setChanges] = useState();
    const [topic, setTopic] = useState();

    console.log('topicsModalPosts', topicsModalPosts)

    const updateData = (value: any) => {
        if (value === 1 || value === -1)
            setTonal(value)
        else
            changeTonal(value)
    }

    const updatePosts = (value: any) => {
        setChanges(value)
        setTonal(value)
    }

    const updateTopic = (value: any) => {
        setTopic(value)
    }

    const changeTonal = (post: any): void => {
        dispatch(showChangePostTonalModal({ post, list: postList }))
    }
    useEffect(() => {
        if (!mentioningSelected) {
            if (mainTopic != null) {
                setIsLoading(true)
                // @ts-ignore
                summaryService.loadSelectTopic(mainTopic.group_id, 'smi', undefined, undefined).then(resp => {
                    console.log('resp', resp)
                    setTimeout(() => {
                        setPostList(resp)
                        setIsLoading(false)
                    }, 1000)
                })
            }
            else setPostList(topicsModalPosts)
            return
        }
    }, [mentioningSelected, tonal, changes, topic])

    const hideTopics = (e: any): void => {
        setIsModalVisible(false)
        setMentioningSelected(false)
    }


    return (
        <>
            <div className="feed-general">

                <div className="summary__wrap">
                    <MainThemes updateTopic={updateTopic} />
                </div>
            </div>

            <Modal
                open={isModalVisible}
                width="80%"
                onCancel={hideTopics}
                footer={null}
                className="topics-modal-parent"
            >
                <div className="topics-modal">
                    <div className="topics-modal__wrap">
                        {topicsModalIsLoading
                            ? (
                                <div className="feed-posts-loader">
                                    <LoadingOutlined />
                                </div>
                            )
                            : topicsModalPosts?.length > 0
                                ? (
                                    <>
                                        <div className="topics-modal__header">
                                            <h2><span className="topics-list-row-info__value">Тема:</span>{mainTopic.title}</h2>
                                            <div className="topics-modal__info">
                                                {/*<p className="topics-list-row__label">Публикаций с упоминанием {type ? 'события' : 'субъекта'}: <span className="topics-list-row-info__value"> {mainTopic.postcount}</span>, охват: <span className="topics-list-row-info__value"> {mainTopic.attendance.toLocaleString('ru-RU')}</span></p>
                          <p className="topics-list-row__label">Всего публикаций в теме: <span className="topics-list-row-info__value"> {mainTopic.total_posts}</span>, охват: <span className="topics-list-row-info__value"> {mainTopic.total_attendance.toLocaleString('ru-RU')}</span></p>
                          */}
                                                <p className="topics-list-row__label">Общее количество публикаций: <span className="topics-list-row-info__value"> {topicsModalPosts?.length}</span>, oхват: <span className="topics-list-row-info__value"> {topicsModalPosts?.reduce((summ, it) => summ + it.attendance, 0)}</span></p>
                                                <p className="topics-list-row__label">Соотношение тональности публикаций: нейтральных - <span className="topics-list-row-info__value">{topicsModalPosts?.filter(it => it.trust !== 1 && it.trust !== -1).length}</span>, позитивных - <span className="topics-list-row-info__value">{topicsModalPosts?.filter(it => it.trust === 1).length}</span>, негативных - <span className="topics-list-row-info__value">{topicsModalPosts?.filter(it => it.trust === -1).length}</span></p>

                                                <div
                                                    className="topics-modal__mentioning"
                                                    onClick={() => setMentioningSelected(prevState => !prevState)}
                                                >

                                                </div>
                                            </div>
                                        </div>
                                        {isLoading
                                            ? (
                                                <div className="feed-posts-loader">
                                                    <LoadingOutlined />
                                                </div>
                                            )
                                            : (
                                                <div className="topics-modal__list">
                                                    {postList?.map((item: any) => 
                                                    /*<PostNew key={item.id} post={item} type="topic" changeTonal={updateData} />*/
                                                    item.id
                                                    )}
                                                </div>
                                            )
                                        }
                                    </>
                                )
                                : (
                                    <div className="topics-modal__empty">Постов пока нет</div>
                                )
                        }
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default FeedGeneral
